import { useMemo } from "react";
import { BOOLEAN_RADIO_INPUT_OPTIONS } from "@constants/boolean-radio-input-options";
import { DO_NOT_SAVE_TO_PDS_PROPERTY_NAME } from "@constants/oidc-login-hint";
import { RpServiceAttributePropertyTypes } from "@enums/rp-service-attribute-property-types";
import { RpServiceAttributeProperty } from "@idw-types/data/reference-data/generic";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { RadioInputFormGroup } from "@containers/common/radio-input-form-group/radio-input-form-group";

type AttributePropertyRadioInputFormGroupProps = {
    controlId: string;
    attributeProperty: RpServiceAttributeProperty;
    className: string;
    isDisabled: boolean;
    value: string;
    updateAttributeProperty: (attributeProperty: RpServiceAttributePropertyTypes, value: string) => void;
};

export const AttributePropertyRadioInputFormGroup = (props: AttributePropertyRadioInputFormGroupProps) => {
    const { controlId, attributeProperty, className, value, isDisabled, updateAttributeProperty } = props;

    const handleAttributePropertyChange = (newValue: string) => {
        if (attributeProperty.name === DO_NOT_SAVE_TO_PDS_PROPERTY_NAME) {
            newValue = isStringTrue(newValue) ? "false" : "true"
        }

        updateAttributeProperty(attributeProperty.name, newValue);
    };

    const attributePropertyValue = useMemo(() => {
        if (attributeProperty.name === DO_NOT_SAVE_TO_PDS_PROPERTY_NAME) {
            return isStringTrue(value) ? "false" : "true";
        }
        return value;
    }, [attributeProperty.name, value]);

    return (
        <RadioInputFormGroup
            controlId={controlId}
            automationId={controlId}
            className={className}
            label={attributeProperty.label}
            value={attributePropertyValue || ''}
            onChange={handleAttributePropertyChange}
            options={BOOLEAN_RADIO_INPUT_OPTIONS}
            isRequired={false}
            disabled={isDisabled}
        />
    );
};